import { ModelBase } from "../ModelBase.js";

export class CommandGroup extends ModelBase {
    private generatedFrom: string;
    private createdOn: Date;
    constructor(json, manualLoad = false) {
        super(json);
        this.category = "commandGroup";
        this.name = json.name || "no name";
        this.generatedFrom = json.generatedFrom || "unknown";
        this.createdOn = new Date(json.createdOn);
        this.dbID = json._id;
        if (isNaN(this.createdOn?.valueOf())) {
            this.createdOn = new Date(Date.now());
        }
        if (!manualLoad) {
            this.load().catch((e) => {
                console.warn(e);
            });
        }
    }
    async load() {
        await super.load();
    }
}
